/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { baseChallengeClipBodySchema } from '../challenge-clip-body-schema';

export const createChallengeClipBodySchema = baseChallengeClipBodySchema.extend({
  collectionId: z.number().int().positive().optional(),
});

export type ICreateChallengeClipBody = z.infer<typeof createChallengeClipBodySchema>;

export interface ICreateChallengeClipRequest {
  challengeId: number;
  body: ICreateChallengeClipBody;
}
